export type MovieType = "movie" | "tv" | "variety";

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  year: number;
  region: string;
  genres: string[];
  director: string;
  actors: string[];
  rating: number;
  plays: number;
  poster: string;
  synopsis: string;
  episodeCount?: number;
}

export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  label: string;
  backdrop: string;
}

export const typeLabels: Record<MovieType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const filterRegions = [
  "全部",
  "中国大陆",
  "美国",
  "中国香港",
  "中国台湾",
  "日本",
  "韩国",
];

export const filterYears = [
  "全部",
  "2025",
  "2024",
  "2023",
  "2022",
  "2021",
  "2019",
];

export const filterGenres = [
  "全部",
  "剧情",
  "科幻",
  "悬疑",
  "动作",
  "犯罪",
  "奇幻",
  "动画",
  "喜剧",
  "古装",
  "爱情",
  "战争",
  "真人秀",
  "音乐",
  "生活",
];

export const sortOptions = [
  { value: "hot", label: "最热" },
  { value: "new", label: "最新" },
  { value: "rating", label: "高分" },
];

export const movies: Movie[] = [
  {
    id: "wandering-earth-3",
    title: "流浪地球3",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "动作", "剧情"],
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "沙溢"],
    rating: 9.2,
    plays: 9800000,
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinema%20poster%20artwork%20of%20a%20giant%20glowing%20planet%20engine%20over%20a%20frozen%20earth%2C%20lone%20astronaut%20silhouette%2C%20deep%20navy%20space%20background%2C%20cinematic%20moody%20lighting%2C%20minimalist%20premium%20streaming%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p01&orientation=portrait",
    synopsis:
      "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。流浪地球计划迎来最艰难的考验，一群普通人挺身而出，为延续人类文明而战。",
  },
  {
    id: "manjianghong",
    title: "满江红",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "悬疑", "古装"],
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    rating: 8.5,
    plays: 7600000,
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20corridor%20at%20night%20with%20lonely%20lanterns%2C%20mysterious%20historical%20drama%20poster%20atmosphere%2C%20deep%20crimson%20and%20navy%20tones%2C%20cinematic%20moody%20lighting%2C%20minimalist%20premium%20streaming%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p02&orientation=portrait",
    synopsis:
      "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一夜之间，小兵张大与亲兵营副统领孙均的命运被卷入一场层层反转的巨大阴谋之中。",
  },
  {
    id: "fengshen-2",
    title: "封神第二部：战火西岐",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["奇幻", "动作", "古装"],
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适", "那尔那茜"],
    rating: 8.8,
    plays: 8900000,
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythology%20epic%20poster%20with%20armored%20warriors%20and%20fiery%20battlefield%2C%20golden%20ornate%20details%20on%20dark%20background%2C%20dramatic%20cinematic%20lighting%2C%20premium%20streaming%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p03&orientation=portrait",
    synopsis:
      "西岐之战全面爆发，姜子牙与姬发带领西岐军民对抗殷商大军。神魔混战，兵戈四起，一场关乎天下命运的史诗对决就此展开。",
  },
  {
    id: "the-battle-at-lake-changjin",
    title: "长津湖",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["战争", "剧情"],
    director: "陈凯歌",
    actors: ["吴京", "易烊千玺", "段奕宏", "朱亚文"],
    rating: 9.0,
    plays: 9200000,
    poster:
      "https://readdy.ai/api/search-image?query=Winter%20battlefield%20soldiers%20advancing%20through%20heavy%20snow%20at%20dawn%2C%20war%20epic%20poster%20atmosphere%2C%20cold%20blue%20grey%20tones%20with%20warm%20ember%20highlights%2C%20cinematic%20dramatic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p04&orientation=portrait",
    synopsis:
      "1950年，中国人民志愿军部队在长津湖地区与美军展开激战。极寒天气下，志愿军战士以血肉之躯筑起钢铁防线，谱写了一曲保家卫国的英雄赞歌。",
  },
  {
    id: "lost-in-the-stars",
    title: "消失的她",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    director: "崔睿",
    actors: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    rating: 8.1,
    plays: 8300000,
    poster:
      "https://readdy.ai/api/search-image?query=Neon%20lit%20rainy%20city%20street%20at%20night%20with%20a%20mysterious%20woman%20silhouette%2C%20tense%20mystery%20thriller%20poster%20mood%2C%20deep%20navy%20and%20teal%20tones%2C%20cinematic%20lighting%2C%20premium%20streaming%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p05&orientation=portrait",
    synopsis:
      "一场精心策划的旅行，一个突然消失的妻子。丈夫何非在异国他乡苦苦寻找真相，却发现所有人都在对他说谎，真相远比他想象的更加残酷。",
  },
  {
    id: "oppenheimer",
    title: "奥本海默",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["剧情", "悬疑"],
    director: "克里斯托弗·诺兰",
    actors: ["基里安·墨菲", "小罗伯特·唐尼", "艾米莉·布朗特"],
    rating: 9.1,
    plays: 8600000,
    poster:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20thoughtful%20scientist%20at%20a%20blackboard%20surrounded%20by%20smoke%20and%20warm%20light%2C%20biographical%20drama%20poster%20mood%2C%20amber%20and%20dark%20charcoal%20tones%2C%20cinematic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p06&orientation=portrait",
    synopsis:
      "聚焦“原子弹之父”罗伯特·奥本海默，讲述他主导曼哈顿计划、研制出世界上第一颗原子弹的传奇经历，以及随之而来漫长的道德与政治拷问。",
  },
  {
    id: "dune-part-two",
    title: "沙丘2",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "动作", "剧情"],
    director: "丹尼斯·维伦纽瓦",
    actors: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森"],
    rating: 8.7,
    plays: 7800000,
    poster:
      "https://readdy.ai/api/search-image?query=Vast%20desert%20planet%20dunes%20under%20a%20huge%20orange%20sun%20with%20a%20lone%20figure%20in%20flowing%20robes%2C%20epic%20sci-fi%20poster%20mood%2C%20sand%20amber%20and%20deep%20shadow%20tones%2C%20cinematic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p07&orientation=portrait",
    synopsis:
      "保罗·厄崔迪与契妮和弗雷曼人并肩作战，踏上复仇之路。当面临一生挚爱与已知宇宙命运的抉择时，他必须竭力阻止只有他自己才能预见的可怕未来。",
  },
  {
    id: "spider-verse-2",
    title: "蜘蛛侠：纵横宇宙",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["动画", "动作", "科幻"],
    director: "华金·多斯·桑托斯",
    actors: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    rating: 9.0,
    plays: 8000000,
    poster:
      "https://readdy.ai/api/search-image?query=Vibrant%20abstract%20comic%20style%20poster%20of%20leaping%20masked%20heroes%20through%20a%20colorful%20portal%20city%2C%20dynamic%20animation%20energy%2C%20neon%20magenta%20and%20cyan%20on%20dark%20background%2C%20bold%20cinematic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p08&orientation=portrait",
    synopsis:
      "迈尔斯·莫拉莱斯穿越多元宇宙，结识了蜘蛛联盟。当他与其他蜘蛛侠对如何处理新威胁产生分歧时，他必须重新定义什么是真正的英雄。",
  },
  {
    id: "someday-or-one-day",
    title: "想见你",
    type: "movie",
    year: 2023,
    region: "中国台湾",
    genres: ["爱情", "奇幻", "悬疑"],
    director: "黄天仁",
    actors: ["许光汉", "柯佳嬿", "施柏宇"],
    rating: 8.3,
    plays: 6400000,
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20poster%20artwork%20of%20a%20young%20couple%20separated%20by%20a%20glowing%20spiral%20of%20time%2C%20warm%20sunset%20gradient%20over%20dark%20sky%2C%20cinematic%20dreamy%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p09&orientation=portrait",
    synopsis:
      "一卷磁带、一首老歌，跨越时空让他们彼此相连。李子维与黄雨萱在命运的漩涡中反复相遇又错过，只为想见你一面。",
  },
  {
    id: "infernal-affairs",
    title: "无间道",
    type: "movie",
    year: 2002,
    region: "中国香港",
    genres: ["犯罪", "剧情", "悬疑"],
    director: "刘伟强",
    actors: ["刘德华", "梁朝伟", "黄秋生", "曾志伟"],
    rating: 9.3,
    plays: 7000000,
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20noir%20poster%20of%20two%20men%20in%20long%20coats%20facing%20away%20in%20a%20rainy%20night%20alley%2C%20harsh%20green%20and%20blue%20lighting%2C%20cinematic%20tense%20atmosphere%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p10&orientation=portrait",
    synopsis:
      "一个是警方派入黑帮的卧底，一个是黑帮安插在警队的卧底。两条命运之线在无间道中交错，谁又能真正走出这场没有尽头的较量。",
  },
  {
    id: "spirited-away",
    title: "千与千寻",
    type: "movie",
    year: 2019,
    region: "日本",
    genres: ["动画", "奇幻", "剧情"],
    director: "宫崎骏",
    actors: ["柊瑠美", "入野自由", "夏木真理"],
    rating: 9.4,
    plays: 9500000,
    poster:
      "https://readdy.ai/api/search-image?query=Hand%20painted%20anime%20style%20poster%20of%20a%20girl%20on%20a%20stone%20stairway%20toward%20a%20glowing%20lantern%20spirit%20world%2C%20teal%20and%20golden%20tones%20on%20dark%20night%20background%2C%20dreamy%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p11&orientation=portrait",
    synopsis:
      "十岁少女千寻随父母误入神灵世界，为了救回变成猪的父母，她在汤屋中努力工作，逐渐学会勇敢与成长，也收获了真挚的友谊。",
  },
  {
    id: "parasite",
    title: "寄生虫",
    type: "movie",
    year: 2019,
    region: "韩国",
    genres: ["剧情", "悬疑", "犯罪"],
    director: "奉俊昊",
    actors: ["宋康昊", "李善均", "曹如晶", "崔宇植"],
    rating: 8.8,
    plays: 6800000,
    poster:
      "https://readdy.ai/api/search-image?query=Conceptual%20social%20thriller%20poster%20of%20a%20modern%20house%20split%20between%20light%20and%20underground%20shadow%2C%20tense%20minimal%20composition%2C%20cool%20grey%20and%20warm%20interior%20tones%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p12&orientation=portrait",
    synopsis:
      "住在半地下室的一家人，凭借精心设计的骗局逐步渗透进富裕家庭。当两个阶层的欲望碰撞，一场关于生存与尊严的黑色悲剧悄然上演。",
  },
  {
    id: "the-knockout",
    title: "狂飙",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["犯罪", "剧情", "悬疑"],
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚"],
    rating: 8.7,
    plays: 9900000,
    episodeCount: 39,
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20drama%20poster%20of%20two%20men%20standing%20opposite%20on%20a%20rainy%20neon%20city%20overpass%2C%20tense%20confrontation%20mood%2C%20deep%20teal%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p13&orientation=portrait",
    synopsis:
      "一名基层刑警与一个鱼贩出身的企业家，在二十年的岁月里彼此纠缠。扫黑除恶的浪潮中，正义与罪恶的较量从未停歇。",
  },
  {
    id: "the-long-season",
    title: "漫长的季节",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "剧情", "犯罪"],
    director: "辛爽",
    actors: ["范伟", "秦昊", "陈明昊", "李庚希"],
    rating: 9.4,
    plays: 8800000,
    episodeCount: 12,
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20drama%20poster%20of%20a%20rusty%20northern%20town%20railway%20at%20dusk%20with%20a%20lone%20figure%2C%20melancholy%20autumn%20tones%2C%20dusty%20amber%20and%20slate%20blue%2C%20cinematic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p14&orientation=portrait",
    synopsis:
      "东北小城桦林，一桩尘封的碎尸案牵动了三个家庭的命运。三个老伙计为了追查真相，在一次次的相遇与告别中，与漫长的季节和解。",
  },
  {
    id: "the-bad-kids",
    title: "隐秘的角落",
    type: "tv",
    year: 2020,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    director: "辛爽",
    actors: ["秦昊", "王景春", "荣梓杉", "史彭元"],
    rating: 8.8,
    plays: 8200000,
    episodeCount: 12,
    poster:
      "https://readdy.ai/api/search-image?query=Ominous%20thriller%20drama%20poster%20of%20three%20children%20silhouettes%20on%20a%20cliff%20facing%20a%20dark%20sea%2C%20unsettling%20summer%20atmosphere%2C%20desaturated%20green%20and%20grey%20tones%2C%20cinematic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p15&orientation=portrait",
    synopsis:
      "三个孩子在景区游玩时无意间拍下了一起谋杀案。他们本想用这份证据换取一个秘密，却一步步滑向无法回头的深渊。",
  },
  {
    id: "empresses-in-the-palace",
    title: "甄嬛传",
    type: "tv",
    year: 2011,
    region: "中国大陆",
    genres: ["古装", "剧情", "爱情"],
    director: "郑晓龙",
    actors: ["孙俪", "陈建斌", "蔡少芬", "蒋欣"],
    rating: 9.4,
    plays: 9300000,
    episodeCount: 76,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20imperial%20palace%20costume%20drama%20poster%20of%20a%20royal%20woman%20in%20ornate%20headwear%20before%20red%20palace%20gates%2C%20regal%20solemn%20mood%2C%20deep%20crimson%20and%20gold%20on%20dark%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p16&orientation=portrait",
    synopsis:
      "少女甄嬛入宫，从天真烂漫到步步为营。在深宫内院的权力漩涡中，她凭借智慧与坚韧，走出一条属于自己的传奇之路。",
  },
  {
    id: "love-between-fairy-and-devil",
    title: "苍兰诀",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["古装", "奇幻", "爱情"],
    director: "伊峥",
    actors: ["虞书欣", "王鹤棣", "张凌赫", "徐海乔"],
    rating: 7.7,
    plays: 7100000,
    episodeCount: 36,
    poster:
      "https://readdy.ai/api/search-image?query=Dreamy%20xianxia%20fantasy%20poster%20of%20a%20couple%20surrounded%20by%20glowing%20lotus%20petals%20and%20starlight%2C%20ethereal%20romantic%20mood%2C%20deep%20blue%20purple%20and%20pink%20glow%20on%20dark%20sky%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p17&orientation=portrait",
    synopsis:
      "天真小仙女的意外闯入，让魔尊冷峻的心湖泛起涟漪。一段跨越仙魔两界的宿命爱恋，在天劫与抉择中悄然绽放。",
  },
  {
    id: "game-of-thrones",
    title: "权力的游戏",
    type: "tv",
    year: 2019,
    region: "美国",
    genres: ["奇幻", "剧情", "战争"],
    director: "大卫·贝尼奥夫",
    actors: ["艾米莉亚·克拉克", "基特·哈灵顿", "彼特·丁拉基"],
    rating: 9.2,
    plays: 9100000,
    episodeCount: 73,
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20medieval%20fantasy%20poster%20of%20an%20iron%20throne%20lit%20by%20torchlight%20inside%20a%20dark%20stone%20hall%2C%20dramatic%20regal%20atmosphere%2C%20deep%20charcoal%20and%20molten%20amber%20tones%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p18&orientation=portrait",
    synopsis:
      "七大王国为争夺铁王座明争暗斗，异鬼大军步步逼近。家族、忠诚、背叛与权力交织成一幅宏大的史诗画卷。",
  },
  {
    id: "stranger-things",
    title: "怪奇物语",
    type: "tv",
    year: 2022,
    region: "美国",
    genres: ["科幻", "悬疑", "剧情"],
    director: "达菲兄弟",
    actors: ["米莉·波比·布朗", "薇诺娜·瑞德", "大卫·哈伯"],
    rating: 8.9,
    plays: 7700000,
    episodeCount: 34,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20eighties%20sci-fi%20horror%20poster%20of%20kids%20on%20bikes%20facing%20a%20red%20glowing%20portal%20above%20a%20small%20town%2C%20nostalgic%20eerie%20mood%2C%20deep%20red%20and%20midnight%20blue%20tones%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p19&orientation=portrait",
    synopsis:
      "小镇男孩神秘失踪，一群好友在寻找他的过程中，揭开了隐藏在平静表面之下的超自然秘密，以及一个危险的平行世界。",
  },
  {
    id: "the-glory",
    title: "黑暗荣耀",
    type: "tv",
    year: 2023,
    region: "韩国",
    genres: ["剧情", "悬疑", "犯罪"],
    director: "安吉镐",
    actors: ["宋慧乔", "李到晛", "林智妍", "朴成焄"],
    rating: 9.0,
    plays: 8400000,
    episodeCount: 16,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20revenge%20drama%20poster%20of%20a%20woman%20in%20a%20dark%20coat%20gazing%20over%20a%20foggy%20night%20city%2C%20cold%20determined%20mood%2C%20deep%20black%20and%20icy%20blue%20tones%2C%20cinematic%20lighting%2C%20premium%20poster%20style%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p20&orientation=portrait",
    synopsis:
      "文东恩将多年承受的校园暴力深埋心底，用一生精心布局。她一步步逼近当年的加害者，只为完成一场漫长而优雅的复仇。",
  },
  {
    id: "keep-running",
    title: "奔跑吧·兄弟",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["真人秀", "喜剧"],
    director: "浙江卫视",
    actors: ["李晨", "郑恺", "杨颖", "白鹿"],
    rating: 7.6,
    plays: 8600000,
    episodeCount: 12,
    poster:
      "https://readdy.ai/api/search-image?query=Energetic%20variety%20show%20poster%20of%20colorful%20silhouettes%20running%20across%20a%20city%20skyline%20at%20night%2C%20playful%20dynamic%20mood%2C%20vivid%20orange%20and%20teal%20accents%20on%20dark%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p21&orientation=portrait",
    synopsis:
      "跑男团再度集结，用一场场脑洞大开的任务和真诚的兄弟情谊，为观众带来欢笑与感动，奔跑的脚步永不停歇。",
  },
  {
    id: "longing-for-life",
    title: "向往的生活",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["真人秀", "生活"],
    director: "湖南卫视",
    actors: ["黄磊", "何炅", "彭昱畅", "张子枫"],
    rating: 8.2,
    plays: 6600000,
    episodeCount: 14,
    poster:
      "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20variety%20poster%20of%20a%20warm%20lit%20farmhouse%20with%20smoke%20rising%20at%20dusk%2C%20cozy%20slow%20living%20mood%2C%20golden%20hour%20warm%20tones%20with%20deep%20green%20shadows%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p22&orientation=portrait",
    synopsis:
      "蘑菇屋再度开张，嘉宾们在田园里种菜做饭、谈天说地。慢下来的时光里，藏着生活最本真的味道。",
  },
  {
    id: "singer-2024",
    title: "歌手2024",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "真人秀"],
    director: "湖南卫视",
    actors: ["那英", "香缇·莫", "凡希亚", "汪苏泷"],
    rating: 8.4,
    plays: 8900000,
    episodeCount: 13,
    poster:
      "https://readdy.ai/api/search-image?query=Dramatic%20music%20competition%20poster%20of%20a%20singer%20silhouette%20under%20a%20single%20spotlight%20with%20glowing%20sound%20waves%2C%20powerful%20stage%20mood%2C%20electric%20orange%20and%20deep%20blue%20tones%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p23&orientation=portrait",
    synopsis:
      "顶级歌手同台竞技，用最真实的声音征服全场。每一首现场演绎都是对音乐最诚挚的告白，一场听觉盛宴就此开启。",
  },
  {
    id: "call-me-by-fire",
    title: "披荆斩棘",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "真人秀"],
    director: "芒果TV",
    actors: ["陈楚生", "张远", "苏醒", "王栎鑫"],
    rating: 8.0,
    plays: 7400000,
    episodeCount: 12,
    poster:
      "https://readdy.ai/api/search-image?query=Inspiring%20music%20show%20poster%20of%20a%20group%20of%20men%20walking%20forward%20through%20glowing%20stage%20light%20beams%2C%20brotherhood%20and%20comeback%20mood%2C%20deep%20indigo%20and%20warm%20gold%20accents%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=97v-p24&orientation=portrait",
    synopsis:
      "一群重新出发的哥哥们，在舞台上乘风破浪、披荆斩棘。他们用汗水与热爱证明，梦想从不因年龄而褪色。",
  },
];

export const heroSlides: HeroSlide[] = [
  {
    id: "wandering-earth-3",
    title: "流浪地球3",
    subtitle: "人类命运共同体的终极一战，中国科幻再攀高峰",
    label: "独家热映",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20wide%20shot%20of%20a%20giant%20glowing%20planetary%20engine%20towering%20over%20a%20frozen%20earth%20beneath%20a%20deep%20navy%20star%20field%2C%20astronaut%20silhouette%20in%20foreground%2C%20dramatic%20atmospheric%20lighting%2C%20film%20still%20high%20detail%2C%20no%20text&width=1600&height=900&seq=97v-h01&orientation=landscape",
  },
  {
    id: "the-long-season",
    title: "漫长的季节",
    subtitle: "一个关于时间、真相与和解的东北往事",
    label: "高分口碑",
    backdrop:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20wide%20shot%20of%20a%20rusty%20northern%20railway%20town%20at%20dusk%20with%20warm%20street%20lamps%20and%20a%20lone%20walking%20figure%2C%20melancholy%20autumn%20dusty%20amber%20and%20slate%20blue%20tone%2C%20film%20still%20high%20detail%2C%20no%20text&width=1600&height=900&seq=97v-h02&orientation=landscape",
  },
  {
    id: "dune-part-two",
    title: "沙丘2",
    subtitle: "踏上复仇之路，见证命运沙海中的史诗抉择",
    label: "科幻巨制",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20wide%20shot%20of%20endless%20desert%20dunes%20under%20a%20huge%20burning%20sun%20with%20a%20lone%20robed%20figure%20on%20a%20ridge%2C%20shimmering%20heat%20haze%2C%20sand%20amber%20and%20deep%20shadow%20tones%2C%20film%20still%20high%20detail%2C%20no%20text&width=1600&height=900&seq=97v-h03&orientation=landscape",
  },
  {
    id: "the-glory",
    title: "黑暗荣耀",
    subtitle: "一场精心布局多年的优雅复仇，就此拉开序幕",
    label: "热播剧集",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20wide%20shot%20of%20a%20woman%20in%20a%20dark%20coat%20standing%20before%20a%20foggy%20night%20city%20skyline%20with%20cold%20blue%20light%2C%20determined%20elegant%20mood%2C%20deep%20black%20and%20icy%20blue%20tones%2C%20film%20still%20high%20detail%2C%20no%20text&width=1600&height=900&seq=97v-h04&orientation=landscape",
  },
  {
    id: "spirited-away",
    title: "千与千寻",
    subtitle: "手绘奇幻经典，一场关于成长与勇气的旅程",
    label: "经典回顾",
    backdrop:
      "https://readdy.ai/api/search-image?query=Hand%20painted%20anime%20cinematic%20wide%20shot%20of%20a%20spirit%20world%20bathhouse%20glowing%20with%20lanterns%20beside%20a%20quiet%20night%20harbor%2C%20teal%20and%20golden%20tones%20on%20deep%20blue%20sky%2C%20dreamy%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=97v-h05&orientation=landscape",
  },
];

export const topics = [
  {
    id: "sci-fi-week",
    title: "硬核科幻周",
    desc: "从星际穿越到行星发动机，一次看够未来的想象",
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20abstract%20space%20scene%20with%20a%20glowing%20planet%20ring%20and%20deep%20navy%20nebula%2C%20minimalist%20premium%20banner%20style%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=97v-t01&orientation=landscape",
  },
  {
    id: "chinese-drama",
    title: "国剧精品季",
    desc: "高分国产剧合集，细品烟火人间与时代变迁",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20abstract%20scene%20of%20a%20traditional%20Chinese%20courtyard%20lantern%20glow%20at%20dusk%2C%20minimalist%20premium%20banner%20style%2C%20emerald%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=97v-t02&orientation=landscape",
  },
  {
    id: "variety-night",
    title: "周末综艺之夜",
    desc: "欢笑与音乐齐飞，承包你的每一个周末",
    image:
      "https://readdy.ai/api/search-image?query=Playful%20abstract%20stage%20scene%20with%20colorful%20spotlights%20and%20confetti%20on%20a%20dark%20background%2C%20minimalist%20premium%20banner%20style%2C%20vivid%20orange%20and%20magenta%20accents%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=97v-t03&orientation=landscape",
  },
];